import { render, staticRenderFns } from "./PowerSocketForm.vue?vue&type=template&id=34b1061e"
import script from "./PowerSocketForm.vue?vue&type=script&lang=js"
export * from "./PowerSocketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports